import { ISession } from "../interfaces/IContext"
import { parseJwt } from "./Cookie"

const mask_cgc = (cgc: string) => {
  let format = ''
  if (cgc === '0' || cgc === undefined || cgc === null) {
    return '00.000.000/0000-00'
  }

  if (cgc.length <= 11) {
    while (cgc.length < 11) {
      cgc = '0' + cgc
    }

    format =
      cgc.substr(0, 3) +
      '.' +
      cgc.substr(3, 3) +
      '.' +
      cgc.substr(6, 3) +
      '-' +
      cgc.substr(9, 2)

    return format
  }

  //cnpj
  while (cgc.length < 14) {
    cgc = '0' + cgc
  }

  format =
    cgc.substr(0, 2) +
    '.' +
    cgc.substr(2, 3) +
    '.' +
    cgc.substr(5, 3) +
    '/' +
    cgc.substr(8, 4) +
    '-' +
    cgc.substr(12, 2)

  return format
}

const inicializa_session = (session?: ISession) => {
  const token = parseJwt()

  if (token && !session) {
    return token
  }
  if (token && session) {
    session.userAzure = token.userAzure
    session.groups = token.groups
  }
  const tokenParse: ISession = {
    azureId: '',
    codEmp: 0,
    exp: 0,
    groups: [],
    iat: 0,
    userAzure: ''
  }
  return tokenParse
}

export {
  mask_cgc,
  inicializa_session
}